import { useState } from 'react';
import Loader from '../../component/common/Loader';

const ShoorahHealthSchemesList = ({ shoorahSchemes, loadingSchemes, onBack }) => {
  const [expandedSchemes, setExpandedSchemes] = useState({});

  const toggleScheme = (schemeId) => {
    setExpandedSchemes((prev) => ({
      ...prev,
      [schemeId]: !prev[schemeId]
    }));
  };

  const handleSpeakToSales = () => {
    // TODO: Implement speak to sales functionality (e.g., open modal, navigate to contact page, etc.)
    window.open('mailto:sales@shoorah.io?subject=Health Scheme Inquiry', '_blank');
  };

  const renderSchemeCard = (plan, schemeId) => {
    const isExpanded = expandedSchemes[schemeId];

    return (
      <div
        key={schemeId}
        className="bg-white dark:bg-shoorah-darkBgTabColor border w-50 border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden"
      >
        {/* Header - Always visible */}
        <div
          className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition"
          onClick={() => toggleScheme(schemeId)}
        >
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{plan.title}</h3>
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform ${
              isExpanded ? 'transform rotate-180' : ''
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {/* Expandable Content */}
        {isExpanded && (
          <div className="px-4 pb-4 space-y-4 border-t border-gray-200 dark:border-gray-600 pt-4">
            <p className="text-sm text-gray-600 dark:text-gray-400">{plan.desc}</p>

            {/* Benefits List */}
            {plan.points && plan.points.length > 0 && (
              <ul className="space-y-2">
                {plan.points.map((point, pointIndex) => (
                  <li
                    key={pointIndex}
                    className="flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300"
                  >
                    <svg
                      className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            )}

            {/* Contact and Info */}
            {/* <div className="flex flex-wrap gap-4 pt-2">
              {plan.contact && (
                <a
                  href={`tel:${plan.contact}`}
                  className="text-sm text-shoorah-primary hover:text-shoorah-secondary font-medium"
                >
                  Contact: {plan.contact}
                </a>
              )}
              {plan.info && (
                <a
                  href={plan.info.startsWith('http') ? plan.info : `https://${plan.info}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-shoorah-primary hover:text-shoorah-secondary font-medium"
                >
                  More info →
                </a>
              )}
            </div> */}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="mt-8 w-[50%]">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Health cash plans</h2>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={handleSpeakToSales}
            className="btn-primary"
          >
            Speak to Sales?
          </button>
        </div>
      </div>

      {loadingSchemes ? (
        <Loader />
      ) : (
        <div className="space-y-6 w-half">
          {/* Health Cash Plans Section */}
          {shoorahSchemes.ShoorahHealthCashPlans &&
            shoorahSchemes.ShoorahHealthCashPlans.length > 0 && (
              <div>
                <div className="space-y-3">
                  {shoorahSchemes.ShoorahHealthCashPlans.map((plan, index) => {
                    const schemeId = `cash-${index}`;
                    return renderSchemeCard(plan, schemeId);
                  })}
                </div>
              </div>
            )}

          {/* Occupational Health Plans Section */}
          {shoorahSchemes.ShoorahOccupationalHealthPlans &&
            shoorahSchemes.ShoorahOccupationalHealthPlans.length > 0 && (
              <div className="mt-8">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                  Occupational health
                </h3>
                <div className="space-y-3">
                  {shoorahSchemes.ShoorahOccupationalHealthPlans.map((plan, index) => {
                    const schemeId = `occupational-${index}`;
                    return renderSchemeCard(plan, schemeId);
                  })}
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default ShoorahHealthSchemesList;
